"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDropdownStyle = void 0;
const types_1 = require("../types");
const helpers_1 = require("../../../helpers");
const createDropdownStyle = (width, popoverWidth) => {
    if (width && popoverWidth === types_1.DROPDOWN_WIDTH.controlWidth) {
        return { width };
    }
    if (width && popoverWidth === types_1.DROPDOWN_WIDTH.minControlWidthAndMaxXXL) {
        return {
            minWidth: width,
            maxWidth: parseInt(helpers_1.FIELD_XXL, 10)
        };
    }
    return {};
};
exports.createDropdownStyle = createDropdownStyle;
//# sourceMappingURL=createDropdownStyle.js.map